export default __webpack_public_path__ + "static/wadline-logo-539fc4a4696aa8db91273b94615a4b52.svg";